import * as React from 'react';
import { omit } from 'rambda';
import { Facet, RefinementType, FacetValue, Refinements } from '@packages/common';
import { RefinementsContext } from '../RefinementsContext';
import { useRefinements } from './useRefinements';
import { toggleFilter$ } from './refinementsEvents';

export const useToggleFilter = (facet: Facet) => {
  const { refinements } = React.useContext(RefinementsContext);
  const { updateFacetFilters } = useRefinements();
  const facetFilters = refinements[RefinementType.FACET_FILTERS];

  const isActive = refinements?.[RefinementType.FACET_FILTERS]?.[facet.featureMapping]?.values?.length > 0;

  const toggle = (facetValue: FacetValue) => {
    if (!facetValue) {
      return;
    }

    const updatedFacetFilters: Refinements[RefinementType.FACET_FILTERS] = isActive
      ? omit([facet.featureMapping], facetFilters)
      : {
          ...facetFilters,
          [facet.featureMapping]: {
            relation: facet.relation,
            seoName: facet.seoName,
            values: [
              {
                featureValue: facetValue.featureValue,
                isHero: facetValue.isHero,
                name: facetValue.name,
                seoName: facetValue.seoName,
              },
            ],
          },
        };

    updateFacetFilters(updatedFacetFilters);
    toggleFilter$.next({ isActive: !isActive, value: Boolean(facetValue.featureValue), seoName: facet.seoName });
  };

  return { toggle, isActive, toggleFilter$ };
};
